import { createFileRoute, Outlet } from "@tanstack/react-router"
import { IconLockFill18 } from "nucleo-ui-fill-18"

import { requireSession } from "@/app/require-session"
import { EmptyState } from "@/components/common/empty-state"
import { PortalShell } from "@/components/layout/portal-shell"
import { SignOutButton } from "@/features/auth/components/sign-out-button"

export const Route = createFileRoute("/$organisation/portal/_portal")({
  beforeLoad: async ({ context, location }) => {
    const { session } = await requireSession(context.queryClient, location)
    const linked =
      session.portal.find(
        (entry) => entry.organisationId === context.brand.id
      ) ?? null

    return { linked, session }
  },
  component: PortalLayout,
})

function PortalLayout() {
  const { brand, linked } = Route.useRouteContext()

  return (
    <PortalShell brand={brand}>
      {linked ? (
        <Outlet />
      ) : (
        <EmptyState
          icon={<IconLockFill18 />}
          title="You don't have access to this portal"
          actions={<SignOutButton />}
        />
      )}
    </PortalShell>
  )
}
